// This is the runtime configuration being used for tests

export const testConfig = {
    backend: {
        PERFORMANCE_PLATFORM_INFO: `${window.location.origin}/platforminfo`,
        USERADMIN_SERVICE: `${window.location.origin}/user-management`,
        PERFORMANCE_MERGER: `${window.location.origin}/api/performcache`,
        QUERY_SERVICE: `${window.location.origin}/api/queryservice`,
        CONNECTED_CODRIVER_SERVICE: `${window.location.origin}`,
        EXCEL_EXPORT_SERVICE: window.location.origin,
        OPCON: `${window.location.origin}/v1`,
        MENU_URL: `${window.location.origin}/menu/rio`,
        TAGS_SERVICE: `${window.location.origin}/tags`,
        ASSETS_SERVICE: `${window.location.origin}/assets`,
        DRIVERS_SERVICE: `${window.location.origin}/drivers`,
        ACCOUNTS_SERVICE: `${window.location.origin}/accounts`,
        SETTINGS_SERVICE: `${window.location.origin}/settings`,
    },
    homeRoute: `${window.location.origin}`,
    id: 'env.test',
    login: {
        authority: `${window.location.origin}/oauth`,
        mockAuthorization: false,
        mockLocale: 'de-DE',
        preventRedirect: false,
        redirectUri: `${window.location.origin}/redirect.html`,
        silentRedirectUri: `${window.location.origin}/redirect.html`,
    },
    logoutUri: `${window.location.origin}`,
};
